import { api } from './index'; // Import the base API



export const getEndpoints = api.injectEndpoints({
  endpoints: (builder) => ({
    getDestinations: builder.query({
      query: (args = {}) => {
        let url = "destinations";
        const queryParams = [];
        // Check if 'q' exists in args and add it to queryParams
        if ("q" in args && args.q) {
          queryParams.push(`q=${encodeURIComponent(args.q)}`);
        }

        // Check if 'page' exists in args and add it to queryParams
        if ("page" in args && args.page) {
          queryParams.push(`page=${encodeURIComponent(args.page)}`);
        }

        if ("difficulty" in args && args.difficulty) {
          queryParams.push(`difficulty=${encodeURIComponent(args.difficulty)}`);
        }

        if ("isTraverse" in args) {
          queryParams.push(`isTraverse=${encodeURIComponent(args.isTraverse)}`);
        }

        // If there are any queryParams, append them to the URL
        if (queryParams.length) {
          url += `?${queryParams.join("&")}`;
        }
        return url;
      },
      providesTags: (results) => [
        { type: "AdminDestinationList", id: "AdminDestinationList" },
      ],
    }),

    getDestinationsWithImage: builder.query({
      query: (args = {}) => {
        let url = "destinations";
        const queryParams = [];

        // Check if 'q' exists in args and add it to queryParams
        if ("q" in args && args.q) {
          queryParams.push(`q=${encodeURIComponent(args.q)}`);
        }

        // Check if 'page' exists in args and add it to queryParams
        if ("page" in args && args.page) {
          queryParams.push(`page=${encodeURIComponent(args.page)}`);
        }

        if ("totalItems" in args && args.totalItems) {
          queryParams.push(`totalItems=${encodeURIComponent(args.totalItems)}`);
        }

        if ("difficulty" in args && args.difficulty) {
          queryParams.push(`difficulty=${encodeURIComponent(args.difficulty)}`);
        }

        if ("isTraverse" in args) {
          queryParams.push(`isTraverse=${encodeURIComponent(args.isTraverse)}`);
        }

        if ("country" in args && args.country) {
          queryParams.push(`country=${encodeURIComponent(args.country)}`);
        }

        queryParams.push(`fetchImage=true`);

        // If there are any queryParams, append them to the URL
        if (queryParams.length) {
          url += `?${queryParams.join("&")}`;
        }
        return url;
      },
      providesTags: (results) => [
        { type: "DestinationList", id: "DestinationList" },
      ],
    }),

    getDestinationsDetail: builder.query({
      query: (args = {}) => {
        let url = `destinations/${args.destinationId}`;
        return url;
      },
      providesTags: (results) => [
        { type: "DestinationDetail", id: "DestinationDetail" },
      ],
    }),

    getAdventuresDetail: builder.query({
      query: (args = {}) => {
        let url = `adventures/${args.adventureId}`;
        return url;
      },
      providesTags: (results) => [
        { type: "AdventureDetail", id: "AdventureDetail" },
      ],
    }),

    getProgrammesDetail: builder.query({
      query: (args = {}) => {
        let url = `programmes/${args.programmeId}`;
        return url;
      },
      providesTags: (results) => [
        { type: "ProgrammeDetail", id: "ProgrammeDetail" },
      ],
    }),

    getDestinationsImages: builder.query({
      query: (args = {}) => {
        let url = `destinations/${args.destinationId}/images`;
        return url;
      },
      providesTags: (results) => [
        { type: "DestinationImages", id: "DestinationImages" },
      ],
    }),

    getDestinationOptions: builder.query({
      query: (args = {}) => {
        let url = "destinations/options";

        return url;
      },
      providesTags: (results) => [
        { type: "DestinationOptions", id: "DestinationOptions" },
      ],
    }),

    getAdventureOptions: builder.query({
      query: (args = {}) => {
        let url = "adventures/options";

        return url;
      },
      providesTags: (results) => [
        { type: "AdventureOptions", id: "AdventureOptions" },
      ],
    }),

    getCountriesOptions: builder.query({
      query: (args = {}) => {
        let url = "Lookups/countries/options";

        return url;
      },
      providesTags: (results) => [
        { type: "CountriesListOptions", id: "CountriesListOptions" },
      ],
    }),

    getAdventures: builder.query({
      query: (args = {}) => {
        let url = "adventures";
        const queryParams = [];

        // Check if 'q' exists in args and add it to queryParams
        if ("q" in args && args.q) {
          queryParams.push(`q=${encodeURIComponent(args.q)}`);
        }

        // Check if 'page' exists in args and add it to queryParams
        if ("page" in args && args.page) {
          queryParams.push(`page=${encodeURIComponent(args.page)}`);
        }

        if ("totalItems" in args && args.totalItems) {
          queryParams.push(`totalItems=${encodeURIComponent(args.totalItems)}`);
        }

        if ("difficulty" in args && args.difficulty) {
          queryParams.push(`difficulty=${encodeURIComponent(args.difficulty)}`);
        }

        if ("type" in args && args.type) {
          queryParams.push(`type=${encodeURIComponent(args.type)}`);
        }
        if ("country" in args && args.country) {
          queryParams.push(`country=${encodeURIComponent(args.country)}`);
        }
        if ("startDate" in args && args.startDate) {
          queryParams.push(`startDate=${encodeURIComponent(args.startDate)}`);
        }

        // If there are any queryParams, append them to the URL
        if (queryParams.length) {
          url += `?${queryParams.join("&")}`;
        }
        return url;
      },
      providesTags: (results) => [
        { type: "AdminAdventureList", id: "AdminAdventureList" },
      ],
    }),

    getProgrammes: builder.query({
      query: (args = {}) => {
        let url = "programmes";
        const queryParams = [];

        // Check if 'q' exists in args and add it to queryParams
        if ("q" in args && args.q) {
          queryParams.push(`q=${encodeURIComponent(args.q)}`);
        }

        // Check if 'page' exists in args and add it to queryParams
        if ("page" in args && args.page) {
          queryParams.push(`page=${encodeURIComponent(args.page)}`);
        }

        if ("totalItems" in args && args.totalItems) {
          queryParams.push(`totalItems=${encodeURIComponent(args.totalItems)}`);
        }

        if ("startDate" in args && args.startDate) {
          queryParams.push(`startDate=${encodeURIComponent(args.startDate)}`);
        }

        if ("endDate" in args && args.endDate) {
          queryParams.push(`endDate=${encodeURIComponent(args.endDate)}`);
        }

        if ("difficulty" in args && args.difficulty) {
          queryParams.push(`difficulty=${encodeURIComponent(args.difficulty)}`);
        }

        // If there are any queryParams, append them to the URL
        if (queryParams.length) {
          url += `?${queryParams.join("&")}`;
        }
        return url;
      },
      providesTags: (results) => [
        { type: "AdminProgrammeList", id: "AdminProgrammeList" },
      ],
    }),

    // ... more post-related endpoints ...
  }),
  overrideExisting: false,
});


export const {
  useGetDestinationsQuery,
  useGetDestinationsWithImageQuery,
  useGetCountriesOptionsQuery,
  useGetDestinationOptionsQuery,
  useGetAdventuresQuery,
  useGetProgrammesQuery,
  useGetAdventureOptionsQuery,
  useGetDestinationsDetailQuery,
  useGetDestinationsImagesQuery,
  useGetAdventuresDetailQuery,
  useGetProgrammesDetailQuery
  // ... export other hooks ...
} = getEndpoints;


export const selectGetDestinationsResult = getEndpoints.endpoints.getDestinations.select(
  {},
);
